export const skipFirstRow = (index, value) => {
  return index != 0 ? value : '';
};

export const toMatrix = (cashflow) => {
  let cashflowRows = [
    [
      'Period',
      'Payment Date',
      'Balance',
      'Interest',
      'Principal',
      'Rate',
      'Cash',
      'Writedown',
      'CPR Rate',
      'CDR Rate',
      'Loss Severity Rate',
      'Delinquency Rate'
    ]
  ];

  for (let row of cashflow) {
    cashflowRows.push([
      row.Period,
      row.PaymentDate,
      row.Balance,
      skipFirstRow(row.Period, row.Interest),
      skipFirstRow(row.Period, row.Principal),
      skipFirstRow(row.Period, row.Rate),
      skipFirstRow(row.Period, row.Cash),
      row.ActualWriteDown,
      skipFirstRow(row.Period, row.CprRate),
      skipFirstRow(row.Period, row.CdrRate),
      skipFirstRow(row.Period, row.LossSeverityRate),
      skipFirstRow(row.Period, row.DelinquencyRate)
    ]);
  }

  return cashflowRows;
};
